import { useMemo } from 'react'

/**
 * Custom hook to create a field map from subsection definition
 * @param {Object} subSection - The subsection object containing fields
 * @returns {Object} Field map with field codes as keys
 */
export function useFieldMap(subSection) {
  return useMemo(() => {
    const fieldMap = {}
    subSection?.fields?.forEach((field) => {
      fieldMap[field.code] = field
    })
    return fieldMap
  }, [subSection])
}
